const cmd = require('./cmd')

function checkoutBranch(branch) {
  const stdout = cmd.execSync(`git checkout ${branch}`)
  return stdout
}

function getCurrentBranch() {
  const stdout = cmd.execSync('git rev-parse --abbrev-ref HEAD')
  return stdout
}

function getBranches() {
  const stdout = cmd.execSync('git branch')
  return stdout.split('\n')
               .map(name => name.trim())
               .filter(name => name.length > 0)
}

function getTags() {
  const stdout = cmd.execSync('git tag')
  return stdout.split('\n')
               .map(name => name.trim())
               .filter(name => name.length > 0)
}

module.exports = {
  checkoutBranch,
  getCurrentBranch,
  getBranches,
  getTags,
}
